import { UtilsTranslation } from './utils.translation.en';

export const utilsTranslation: UtilsTranslation = {
  dictionaries: {
    yesNo: {
      no: 'Nie',
      yes: 'Tak',
    },
  },
};
